export function slugifyServiceLabel(label) {
  return String(label || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/['’]/g, '')
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_|_$/g, '');
}

// Slugs d'URL des catégories (backend : services.slug) → ids camelCase utilisés
// dans serviceCatalog.categories des fichiers de langue.
const CATEGORY_SLUG_TO_ID = {
  'meuble-decoration': 'furniture',
  'cuisine': 'kitchen',
  'salle-de-bain': 'bathroom',
  'sol-mur': 'floorWall',
  'plomberie-chauffage': 'plumbing',
  'electricite': 'electricity',
  'menuiserie': 'carpentry',
  'jardinage': 'gardening',
  'menage-nettoyage': 'cleaning',
  'demenagement': 'moving',
  'securite-serrurerie': 'security',
  'mecancien': 'mechanic',
};

/** Accepte un slug d'URL ou un id de catégorie et renvoie l'id de catégorie. */
export function resolveCategoryId(categoryIdOrSlug) {
  return CATEGORY_SLUG_TO_ID[categoryIdOrSlug] || categoryIdOrSlug;
}

// t() journalise un avertissement sur chaque clé absente : on évite le bruit en
// testant d'abord l'existence via t.has() quand il est disponible.
function translateKey(t, key) {
  if (typeof t.has === 'function' && !t.has(key)) return null;
  const val = t(key);
  return val !== key ? val : null;
}

/** Translate a service or sub-service label; falls back to original French text. */
export function translateServiceLabel(t, label) {
  if (!label) return '';
  const slug = slugifyServiceLabel(label);
  return translateKey(t, `serviceCatalog.sub.${slug}`)
    || translateKey(t, `serviceCatalog.main.${slug}`)
    || label;
}

/** Translate a sub-service dictionary key (ex. « montage_meubles »). */
export function translateSubKey(t, key) {
  return translateKey(t, `serviceCatalog.sub.${key}`) || key;
}

/** Translate any field (name, subtitle, …) of a main category by slug or id. */
export function translateCategoryField(t, categoryId, field) {
  const id = resolveCategoryId(categoryId);
  return translateKey(t, `serviceCatalog.categories.${id}.${field}`) || '';
}

/** Translate main category name by slug or stable id (kitchen, plumbing, …). */
export function translateCategory(t, categoryId) {
  return translateCategoryField(t, categoryId, 'name') || categoryId;
}
